module.exports = __webpack_public_path__ + "static/media/þór.7c5d640a.svg";